var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreshTalentStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6643 5.14641C22.8681 0.198406 29.0663 -1.4624 32.5829 2.22079L45.2711 15.5097C46.1218 16.4009 47.2102 17.0293 48.4073 17.3204L66.26 21.6643C71.208 22.8681 72.8688 29.0663 69.1856 32.5829L55.8967 45.2711C55.0055 46.1218 54.3771 47.2102 54.086 48.4073L49.7421 66.26C48.5383 71.208 42.3401 72.8688 38.8235 69.1856L26.1353 55.8967C25.2846 55.0055 24.1962 54.3771 22.9991 54.086L5.14641 49.7421C0.1984 48.5383 -1.4624 42.3401 2.22078 38.8235L15.5097 26.1353C16.4009 25.2846 17.0292 24.1962 17.3204 22.9991L21.6643 5.14641Z",
    fill: "url(#paint0_linear_826_16000)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_826_16000",
    x1: 49.2031,
    y1: 95.5,
    x2: 20.7031,
    y2: -9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE70FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575986,
    stopColor: "#AE70FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE70FC",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshTalentStar);
export default __webpack_public_path__ + "static/media/FreshTalentStar.c1b4d0ee7738cca618b1bf89f909c01d.svg";
export { ForwardRef as ReactComponent };